module.exports = "/build/web/svg/sponsor/into-the-source.ec9620fb3ba20caf2b67de85e92532ee.svg";


//////////////////
// WEBPACK FOOTER
// ./svg/sponsor/into-the-source.svg
// module id = 214
// module chunks = 24